<template lang="pug">
  .main_container(v-click-outside="onClickOutside")
    .store_container
      .store(@click="dropdownOpen =!dropdownOpen")
        span {{showValue}}
        v-icon.i_arrow.down(v-if="!dropdownOpen" name="sort-down")
        v-icon.i_arrow.up(v-if="dropdownOpen" name="sort-up")
      button.delete(:tabindex="-1" @click="clear") ✖
    .options_container
      .options(
        v-if="dropdownOpen"
        v-for="option in options"
        @click="pickValue(option.id, option.name)"
        ) {{option.name}}
    .error(v-if="error") {{error[0]}}
</template>
<script>
import Icon from 'vue-awesome/components/Icon'
import vClickOutside from 'v-click-outside'

export default {
  props: ['options', 'value', 'defaultValue', 'error'],
  components: {
    'v-icon': Icon
  },
  mounted () {
    setTimeout(() => {
      this.showValue = this.defaultValue || null
    }, 500)
  },
  data () {
    return {
      dropdownOpen: false,
      showValue: null
    }
  },

  watch: {
    value () {
      if (!this.value) {
        this.showValue = null
      }
    }
  },
  methods: {
    clear () {
      this.value = null
      this.showValue = null
      this.$emit('input', null)
    },
    pickValue (id, name) {
      this.dropdownOpen = false
      this.value = id
      this.showValue = name
      this.$emit('input', this.value)
    },
    onClickOutside () {
      if (this.dropdownOpen) {
        this.dropdownOpen = false
      }
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  }
}
</script>
<style lang="sass" scoped>

.fade-enter-active, .fade-leave-active
  transition: opacity .35s
.fade-enter, .fade-leave-to
  opacity: 0

.main_container
  display: grid
  grid-template-columns: 1fr
  position: relative
.store_container
  display: grid
  grid-template-columns: auto 50px
.store
  display: flex
  align-items: center
  height: 32px
  border: 1px solid #ccc
  border-radius: 4px 0 0 4px
  padding-left: 7px
  font-size: 15px
  cursor: pointer
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
.i_arrow
  position: absolute
  right: 65px
.options_container
  max-height: 300px
  overflow: auto
  background: white
  top: 34px
  position: absolute
  width: 99.6%
  z-index: 100
  border: 1px solid #ccc
  border-top: none
  border-bottom: none
  box-shadow: 0 3px 15px -10px black
.options
  display: flex
  align-items: center
  border: none
  cursor: pointer
  padding-left: 7px
  font-size: 15px
  height: 32px
  font-weight: 450
  white-space: pre-wrap
  overflow: visible
  text-overflow: ellipsis
.options:last-child
  border-bottom: 1px solid #ccc
.options:hover
  background: #1e90ff
  color: white
button
  border-radius: 0 4px 4px 0
  border: 1px solid #ccc
  border-left: none
  background: white
  display: grid
  align-content: center
  justify-content: center
  cursor: pointer
  outline: none
.delete:hover
  transition: all, .3s
  color: #e2211d
  font-weight: bold
.error
  margin-top: 5px
  font-size: 15px
  color: #e53935
</style>
